import { useApiResource } from '~/composables/api/useApiResource'
import { useFilesApi } from '~/composables/api/useFilesApi'

export const useBugReportApi = () => {
  const { customEndpoint } = useApiResource('bug-reports', {
    deserialize: true,
    methods: {
      list: false,
      getById: false,
      create: false,
      update: false,
      delete: false
    }
  })

  const { requestTmpUpload } = useFilesApi()

  const sendBugReport = customEndpoint((data) => ({
    url: '/bug-reports',
    method: 'POST',
    data,
    deserialize: false
  }))

  const uploadScreenshot = async (file) => {
    const { data } = await requestTmpUpload({
      fileName: file.name,
      mimeType: file.type,
      size: file.size
    })

    const formData = new FormData()
    Object.entries(data.attributes.uploadFields).forEach(([key, value]) => {
      formData.append(key, value)
    })
    formData.append('file', file)

    await $fetch(data.attributes.uploadUrl, {
      method: 'POST',
      body: formData
    })

    return data.attributes.tempPath
  }

  return {
    sendBugReport,
    uploadScreenshot
  }
}
